import {useEffect} from "react";

let lockCount = 0;
let originalOverflow = "";

const lock = () => {
  if (lockCount === 0) {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount++;
};

const unlock = () => {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = originalOverflow;
  }
};

const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;
    lock();
    return () => unlock();
  }, [isLocked]);
};

export default useScrollLock;
